export const autoRefresh = {
  // give time in milliseconds
  dashboard: {
    SESSION_SUMMARY: 10000,
    CHARGING_STATION: 300000,
    FEE_COLLECTED: 15 * 60 * 1000, // 15 minutes in milliseconds
    ENERGY_USAGE: 15 * 60 * 1000, // 15 minutes in milliseconds
    CONNECTORS: 300000,
    TOTAL_SESSIONS: 10000,
    TELEMATICS_API_CALL_INTERVAL: 300000,
  },
  chargingStation: {
    GET_SITES: 3600000,
    CHARGING_STATION: 10000,
    TOTAL_CAPACITY: 10000,
    CONNECTORS: 300000,
  },
  gridify: {
    /** GET demand view summary (capacity / instant load KPIs) */
    DEMAND_VIEW_SUMMARY: 10000,
    /** GET demand view table / charger rows */
    DEMAND_VIEW_DATA: 10000,
    /** GET demand view live graph series */
    DEMAND_VIEW_GRAPH: 10000,
    /** GET gridify power-management / power logic table */
    POWER_LOGIC: 10000,
  },
  sessions: {
    IN_PROGRESS: 10000,
    IN_HISTORY: 60000,
  },
  rfid: {
    SUMMARY: 300000,
  },
  DEFAULT: 10000, // 10 sec
};
